export default class InstallmentsManager {
    constructor(modalSelector, uiManager) {
        this.modalSelector = modalSelector;
        this.uiManager = uiManager;
        this.currentXhr = null;
    }

    initializeInstallmentsHandling() {
        jQuery('input[name="payment_method"]').on('change', (e) => {
            const $this = jQuery(e.currentTarget);
            if ($this.val() === 'vindi-pagamentos-credit') {
                if ($this.data('token')) {
                    this.getInstallments($this.data('token'));
                }
            }
        });
    }

    getInstallments(token = null, price = null) {
        if (this.currentXhr) {
            this.currentXhr.abort();
        }

        let finalPrice = price;
        if (!finalPrice) {
            const totalElement = jQuery('.total-value');
            if (totalElement.length) {
                const totalText = totalElement.text().replace(/[^\d,.-]/g, '').replace(',', '.');
                finalPrice = parseFloat(totalText);
            }
            
            if (!finalPrice || isNaN(finalPrice)) {
                const basePrice = parseFloat(jQuery('#wvp-cart-total-price').val() || 0);
                const quantity = parseInt(jQuery('#vindi-one-click-quantity').val() || 1);
                finalPrice = basePrice * quantity;
            }
        }
        
        const nonce = jQuery('#wvp-card-nonce').val();

        this.resetInstallmentsError();
        this.uiManager.setRequestLoader();

        const data = {
            price: finalPrice.toFixed(2),
            _wpnonce: nonce || vindiOneClick.nonce,
            security: typeof wc_checkout_params !== 'undefined' ?
                wc_checkout_params.update_order_review_nonce :
                vindiOneClick.nonce
        };

        if (token) {
            data.token = token;
        } else if (jQuery('#wvp-card-brand').length && jQuery('#wvp-card-brand').val()) {
            data.brand = jQuery('#wvp-card-brand').val();
        }

        const ajaxUrl = typeof wc_checkout_params !== 'undefined' ?
            wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'checkout_installments') :
            vindiOneClick.ajax_url + '?wc-ajax=checkout_installments';

        this.currentXhr = jQuery.ajax({
            url: ajaxUrl,
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(data),
            success: (response) => {
                if (response.success) {
                    const installments = response.data.installments;

                    let targetSelector;
                    if (token) {
                        targetSelector = `.saved-card:has(input[data-token="${token}"]) select[name="wvp-installments"]`;
                    } else {
                        targetSelector = '#wvp-card-installments';
                    }

                    const selects = jQuery(targetSelector);

                    if (response.data.message) {
                        this.showInstallmentsMessage(response.data.message);
                    }

                    if (selects.length) {
                        selects.each(function () {
                            const select = jQuery(this);
                            select.empty();

                            Object.entries(installments).forEach(([key, value]) => {
                                select.append(jQuery('<option>', {
                                    value: key,
                                    text: value
                                }));
                            });
                        });
                    } else {
                        console.warn('Seletor de parcelas não encontrado:', targetSelector);
                    }
                } else {
                    this.showInstallmentsError(response.data.message || 'Erro ao carregar parcelas');
                }
            },
            error: (xhr, status, error) => {
                if (status !== 'abort') {
                    this.showInstallmentsError('Não foi possível carregar as parcelas. Tente novamente.');
                }
            },
            complete: () => {
                this.uiManager.removeRequestLoader();
            }
        });
    }

    showInstallmentsMessage(message) {
        const errorElement = jQuery('#wvp-installments-error');
        if (errorElement.length && message) {
            errorElement.html(message).addClass('active');
        }
    }

    showInstallmentsError(message) {
        const errorElement = jQuery('#wvp-installments-error');
        if (errorElement.length) {
            errorElement.html(message).addClass('active');
        }
    }

    resetInstallmentsError() {
        const errorElement = jQuery('#wvp-installments-error');
        if (errorElement.length) {
            errorElement.html('').removeClass('active');
        }
    }
}